import { useEffect, useState } from "react";

const useTitle = (titleText: string) => {
          const [title, setTitle] = useState("");

          useEffect(() => {
                    document.title = titleText + " - বগুড়া পলিটেকনিক ইন্সটিটিউট";
                    setTitle(titleText);
          }, [titleText]);

          return [title];
};

export default useTitle;
